const GWP_GATE_CLAIM_EVENT = 'gwp:checkout-gate:claim';
const GWP_GATE_RELEASE_EVENT = 'gwp:checkout-gate:release';
const GWP_GATE_LOADING_ATTRIBUTE = 'data-gwp-checkout-gate-loading';
const BOOTSTRAP_BUTTON_ATTRIBUTE = 'data-gwp-gate-bootstrap-initializing';
const BOOTSTRAP_ACCELERATED_ATTRIBUTE = 'data-gwp-gate-bootstrap-accelerated';
const STANDARD_CHECKOUT_SELECTOR = '.js-checkout-button';
const ACCELERATED_CHECKOUT_SELECTOR = '[data-gwp-gated-accelerated-checkout]';
const CONTROLLER_ACCELERATED_ATTRIBUTE = 'data-gwp-gated-checkout-blocked';
const CONTROLLER_LOAD_TIMEOUT_MS = 10000;

let settled = false;

document.documentElement.setAttribute(GWP_GATE_LOADING_ATTRIBUTE, '');

const loadingStyle = document.createElement('style');
loadingStyle.textContent = `html[${GWP_GATE_LOADING_ATTRIBUTE}] ${ACCELERATED_CHECKOUT_SELECTOR} { opacity: 0.5; pointer-events: none; }`;
document.head.append(loadingStyle);

/** @param {Element} button */
function lockStandardCheckout(button) {
  if (!(button instanceof HTMLButtonElement) || !button.matches(STANDARD_CHECKOUT_SELECTOR)) return;
  if (button.disabled) return;

  button.disabled = true;
  button.setAttribute(BOOTSTRAP_BUTTON_ATTRIBUTE, '');
  button.setAttribute('aria-busy', 'true');
}

/** @param {Element} container */
function lockAcceleratedCheckout(container) {
  if (!(container instanceof HTMLElement) || !container.matches(ACCELERATED_CHECKOUT_SELECTOR)) {
    return;
  }

  container.inert = true;
  container.setAttribute(BOOTSTRAP_ACCELERATED_ATTRIBUTE, '');
  container.setAttribute('aria-disabled', 'true');
}

/** @param {Node} node */
function lockStandardCheckoutWithin(node) {
  if (!(node instanceof Element)) return;
  lockStandardCheckout(node);
  lockAcceleratedCheckout(node);
  node.querySelectorAll(STANDARD_CHECKOUT_SELECTOR).forEach(lockStandardCheckout);
  node.querySelectorAll(ACCELERATED_CHECKOUT_SELECTOR).forEach(lockAcceleratedCheckout);
}

const checkoutObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    mutation.addedNodes.forEach(lockStandardCheckoutWithin);
  }
});
checkoutObserver.observe(document.documentElement, { childList: true, subtree: true });

function releaseBootstrapLock() {
  document.documentElement.removeAttribute(GWP_GATE_LOADING_ATTRIBUTE);
  checkoutObserver.disconnect();

  document.querySelectorAll(`[${BOOTSTRAP_BUTTON_ATTRIBUTE}]`).forEach((button) => {
    if (!(button instanceof HTMLButtonElement)) return;
    button.disabled = false;
    button.removeAttribute(BOOTSTRAP_BUTTON_ATTRIBUTE);
    button.removeAttribute('aria-busy');
  });

  document.querySelectorAll(`[${BOOTSTRAP_ACCELERATED_ATTRIBUTE}]`).forEach((container) => {
    if (!(container instanceof HTMLElement)) return;
    container.removeAttribute(BOOTSTRAP_ACCELERATED_ATTRIBUTE);

    if (!container.hasAttribute(CONTROLLER_ACCELERATED_ATTRIBUTE)) {
      container.inert = false;
      container.removeAttribute('aria-disabled');
    }
  });
}

function settleBootstrap() {
  if (settled) return;
  settled = true;
  window.clearTimeout(controllerLoadTimeout);
  releaseBootstrapLock();
}

function claimGate() {
  const checkoutComponent = document.querySelector('checkout-button');
  if (checkoutComponent && !customElements.get('checkout-button')) {
    customElements.whenDefined('checkout-button').then(settleBootstrap);
    return;
  }

  settleBootstrap();
}

document.addEventListener(GWP_GATE_CLAIM_EVENT, claimGate, { once: true });
document.addEventListener(GWP_GATE_RELEASE_EVENT, settleBootstrap, { once: true });

const controllerLoadTimeout = window.setTimeout(() => {
  settleBootstrap();
  console.error('Gift with purchase: controller load timed out');
}, CONTROLLER_LOAD_TIMEOUT_MS);
